var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from "react";
import Player from "../../components/ui/Player/Player";
import { useSelector } from "react-redux";
import { selectLoadingDetect, selectSupportEmail, selectVideoTestUrl } from "@adm-media/adam-store-plugin";
import { Result } from "antd";
import Button from "../../components/ui/Buttons/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "../../components/blocks/Navbar/Navbar";
import Footer from "../../components/blocks/Footer/Footer";
import Row from "../../components/ui/Row/Row";
import PlayerDiagnostics from "../../components/blocks/PlayerDiagnostics/PlayerDiagnostics";
import "../../components/ui/Player/Player.scss";
import "../../components/ui/Player/Wrapper.scss";
import "./Videotest.scss";
import NavbarActions from "../../components/ui/NavbarActions/NavbarActions";
export var VideotestPage = function () {
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var videoTestUrl = useSelector(selectVideoTestUrl);
    // Where a failing report should be sent, so the panel can name the address
    // instead of leaving the tester to work it out. Configured per event and
    // delivered with /event/detect.
    var supportEmail = useSelector(selectSupportEmail);
    var loadingDetect = useSelector(selectLoadingDetect);
    // The player instance and the element it lives in, both needed by the
    // diagnostics panel: the instance for the public events the guided checks
    // listen to, the element to reach the underlying video.js for telemetry.
    var playerContainerRef = useRef(null);
    var _a = useState(undefined), player = _a[0], setPlayer = _a[1];
    // The panel is a testing tool, and showing it to every visitor would itself
    // betray that the stream is not a real live feed.
    var showDiagnostics = searchParams.get("diag") === "1" || process.env.NODE_ENV !== "production";
    // `?simulate=warn` / `?simulate=fail` seed the guided run with a canned
    // outcome, so the summary, the selective re-run and the support report can
    // be checked in a browser without having to break the stream first. It only
    // reaches the panel, which is already gated above.
    var simulateParam = searchParams.get("simulate");
    var simulate = simulateParam === "warn" || simulateParam === "fail" ? simulateParam : undefined;
    // Interactive mode asks the tester to confirm each feature actually worked
    // for them. Deployment-wide rather than per-visit, so it is an env var and
    // not a query param: the guided run either interrogates testers on this
    // build or it does not.
    var interactive = process.env.VIDEOTEST_INTERACTIVE === "true";
    var sourceString = videoTestUrl || process.env.DEMO_PLAYER_SRC;
    // Memoised on the URL, not rebuilt per render: the player's source effect keys
    // off this object, and a fresh identity makes it re-issue the source, which
    // reloads the media from the start. The whole tree re-renders on every
    // visibilitychange (App subscribes to it through useModeratorPusherConnection),
    // so an inline literal here turns a tab switch into a restart.
    var source = useMemo(function () { return ({ sources: [{ src: sourceString }] }); }, [sourceString]);
    if (loadingDetect === "uninitialized" || loadingDetect === "pending")
        return null;
    return (_jsxs(Row, __assign({ "data-testid": "videotest", className: "videotest" }, { children: [_jsx(Navbar, { actions: _jsx(NavbarActions, {}), affix: true, verticalSpacing: "small", className: "videotest__navbar" }), !!sourceString ? (_jsxs("div", __assign({ className: "videotest__stage ".concat(showDiagnostics ? "videotest__stage--with-diagnostics" : "") }, { children: [_jsx("div", __assign({ className: "videotest__player", ref: playerContainerRef }, { children: _jsx(Player, { autoplay: true, isFakeLive: true, loop: true, source: source, widescreen: true, forceLiveUi: true, muted: true, hideSpeed: true, onPlayerReady: setPlayer }) })), showDiagnostics && (_jsx("div", __assign({ className: "videotest__diagnostics" }, { children: _jsx(PlayerDiagnostics, { player: player, containerRef: playerContainerRef, simulate: simulate, interactive: interactive, supportEmail: supportEmail }) })))] }))) : (_jsx("div", __assign({ "data-testid": "no-videotest-message" }, { children: _jsx(Result, { status: "404", title: "No test source has been set yet", subTitle: "Please be patient while we take care of it", extra: _jsx(Button, __assign({ onClick: function () { return navigate("/"); } }, { children: "Go to the homepage" })) }) }))), _jsx(Footer, {})] })));
};
